// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalOverlay_backdrop__Bs8fZ"};